import { useEffect } from 'react';
import { useAppStore } from '@/stores/app-store';
import { tickDrones } from '@/services/drone-attacks';

const INTERVAL_MS = 150; // slightly slower than missiles — drones are slower

export function useDroneAnimation(enabled: boolean) {
  const setDroneAttacks = useAppStore((s) => s.setDroneAttacks);

  useEffect(() => {
    if (!enabled) return;

    const tick = () => setDroneAttacks(tickDrones(Date.now()));
    tick();
    const id = setInterval(tick, INTERVAL_MS);
    return () => clearInterval(id);
  }, [enabled, setDroneAttacks]);
}
